import { SendOfflineVerificationFeedbackArgs } from '../types/offline-verification-feedback'

export const sendOfflineVerificationFeedbackArgsToParams = ({
  rating,
  comment,
  finalized,
  feedbackStatementIds,
}: SendOfflineVerificationFeedbackArgs) => ({
  feedback_ratings: {
    rating,
    comment,
    finalized,
    feedback_statement_ids: feedbackStatementIds,
  },
})
